import styled from "styled-components";
import { Div } from "components";
import { Grid } from "@mui/material";

export const Chart = styled(Div)`
  padding: 32px;
  display: flex;
  justify-content: start;
  margin-top: 2px;
  overflow-x: auto;
`;

export const AssetsList = styled.ul`
  width: fit-content;
  list-style-type: none;
`;

export const Spacer = styled.li`
  padding: 104px 0 16px 12px;
  color: transparent;
  font-family: ${({ theme }) => theme.fonts.primary};
`;

export const AssetsItem = styled.li`
  min-height: 50px;
  text-decoration: none;
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  font-family: ${({ theme }) => theme.fonts.primary};
  color: ${({ theme }) =>
    theme.colors[theme.textColors.primary.color][
      theme.textColors.primary.intensity
    ]} !important;
  padding: 14px 0 12px;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

// export const Content = styled(Div)`
//   display: flex;
//   margin-bottom: 35px;
//   width: fit-content;
//   flex-direction: column;

// `;

export const Content = styled(Grid)`
  && {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
`;

export const FirstRow = styled(Grid)`
  && {
  }
`;

export const SecondRow = styled(Grid)`
  && {
    display: flex;
    flex-direction: row;
    width: fit-content;
  }
`;

export const Legend = styled(Div)`
  padding-left: 47px;
  width: fit-content;
`;

export const ChartContainer = styled(Grid)``;

export const Title = styled(Div)`
  font-family: Open Sans;
  font-style: normal;
  line-height: 24px;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  padding-top: 12px;
  padding-left: 26px;
  font-family: ${({ theme }) => theme.fonts.primary};
  color: ${({ theme }) =>
    theme.colors[theme.textColors.primary.color][
      theme.textColors.primary.intensity
    ]} !important;
  width: fit-content;
`;
